module.exports = __webpack_public_path__ + "img/Cabbage.9786a020.svg";